<template>
  <section class="special-gifts-contacts">
    <v-container>
      <div class="special-gifts-contacts__content d-flex flex-column align-center">
        <h2 class="text-center">наши контакты</h2>

        <div class="special-gifts-contacts__contact d-flex flex-column flex-md-row">
          <div class="special-gifts-contacts__contact-img align-self-center">
            <v-img :src="contacts.img" cover></v-img>
          </div>

          <div class="special-gifts-contacts__contact-text d-flex flex-column align-start color-gray">
            <h2 class="special-gifts-contacts__contact-name color-gray" v-html="contacts.name"></h2>
            <div class="special-gifts-contacts__contact-position size2" v-html="contacts.position"></div>
            <a href="tel:+7 (953) 178-42-59" class="special-gifts-contacts__contact-phone color-gray h5" v-html="contacts.phone"></a>
            <a href="mailto:podarki@schastye.com" class="special-gifts-contacts__contact-email color-gray h5" v-html="contacts.email"></a>
          </div>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'special-gifts-contacts',
  data() {
    return {
      
    }
  },
  computed: {
    contacts() {
      const c = this.$store.state.page.SpecialGiftsController.texts['special-gifts-contacts'];
      const img = c.PREVIEW_PICTURE;
      const [name, position] = c.PREVIEW_TEXT.split('\r\n');
      const [phone, email] = c.DETAIL_TEXT.split('\r\n');
      return {img, name, position, phone, email};
    }
  },
}
</script>

<style lang="scss">
.special-gifts-contacts {
  background-color: $black-alpha-06;
  margin-top: 48px;
  
  @include up($md) {
    margin-top: 100px;
  }

  & > .container {
    padding-top: 28px;
    padding-bottom: 48px;

    @include up($md) {
      padding-top: 48px;
      padding-bottom: 130px;
    }
  }

  &__content {
    gap: 38px;
    
    @include up($md) {
      gap: 86px;
    }
  }

  &__contact {
    gap: 42px;

    &-img {
      width: 107px;
      height: 107px;
      border-radius: 50%;
      overflow: hidden;
      
      @include up($md) {
        width: 122px;
        height: 122px;
      }
    }

    &-text {
      gap: 5px;
    }
    
    &-phone {
      margin-top: 15px;
    }

    &-email {
      margin-top: 10px;
    }
  }
}
</style>